import { styled } from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    gap: 24px;

    & > div {
        width: 50%;
    }

    @media screen and (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        justify-content: center;

        & > div {
            width: 100%;
            align-items: center;
            display: flex;
            justify-content: center;
        }
    }
`;

export const ImagePageError = styled.img`
    width: 100%;
    max-width: 328px;
`;